import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('apiSecrets', app)
  return store
}
